app.controller('studentWelcome1Ctrl', [
    '$scope', '$interval', 'Upload', 'gameService', 'welcomeService', '$state', 'keyboardService', function ($scope, $interval, Upload, gameService, welcomeService, $state, keyboardService) {

        var vm = this;

        vm.gameService = gameService;
        vm.welcomeService = welcomeService;

        vm.keyboardShown = keyboardService.isShown;
        $scope.$on('keyboardShownChanged', function(event, args) {
            vm.keyboardShown = args.shown;
        });   

        var now = new Date();
        var startTime = vm.gameService.startTime;
        var timeRemainingMsecs = startTime.getTime() - now.getTime();
        vm.timeRemainingSecs = parseInt(timeRemainingMsecs / 1000.0, 10);

        vm.onTeamInfoUpdated = function() {
            if (!welcomeService.teamImageURL) {
                welcomeService.w1imageStyle["background-image"] = "url(\"/img/defaultteam.svg\")";
            } else {
                welcomeService.w1imageStyle["background-image"] = "url(\"" + welcomeService.teamImageURL + "\")";
            }
        }

        vm.onTeamInfoUpdated();

        $scope.$watch(angular.bind(vm, function () {
            vm.onTeamInfoUpdated();
        }));

        vm.uploading = false;
        vm.upload = function (file) {
            if (file == null) {
                return;
            }

            vm.uploading = true;
            gameService.uploadTeamImage(file).then(function(url) {
                welcomeService.teamImageURL = url;
                vm.uploading = false;
            }, function() {
                vm.uploading = false;
            });
        }

        vm.updateClockDisplay = function() {
            var trs = vm.timeRemainingSecs;
           
            var hr = parseInt(Math.floor(trs / 3600));
            trs -= (hr * 3600);

            var mr = parseInt(Math.floor(trs / 60));
            trs -= (mr * 60);
            
            vm.daysRemain = Math.floor(hr / 24.0);
            vm.hoursRemain = hr;
            vm.minutesRemain = mr;
            vm.secondsRemain = trs;
        }

        vm.updateClockDisplay();

        vm.countdownId = $interval(function() {
            vm.timeRemainingSecs -= 1;
            vm.updateClockDisplay();
        }, 1000);

        $scope.$on('$destroy', function() {
            $interval.cancel(vm.countdownId);
        });

        vm.onTeamNameChanged = function() {
            if (!welcomeService.teamName) {
                $scope.$parent.enabledPages[0] = false;
                $scope.$parent.enabledPages[1] = false;
            } else {
                $scope.$parent.enabledPages[0] = true;
                $scope.$parent.enabledPages[1] = true;
            }
        }

        $scope.$watch('welcomeService.teamName', angular.bind(vm, function() {
            vm.onTeamNameChanged();
        }));

        vm.next = function() {
            $scope.$parent.nextPage();
        }

        $scope.$on('carouselPageChange', function(event, args) {
            if (args.prevPage == 0 && args.newPage == 1) {
                gameService.setTeamInfo({
                    teamName: welcomeService.teamName,
                    teamImageURL: welcomeService.teamImageURL
                });
            }
        });
    }
]);